var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoicePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invoice_download",
    "data-name": "Invoice download",
    transform: "translate(-1817 -338)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6130",
    "data-name": "Rectangle 6130",
    width: 28,
    height: 28,
    transform: "translate(1817 338)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Invoice_download-2",
    "data-name": "Invoice download",
    transform: "translate(1844.111 337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65838",
    "data-name": "Group 65838",
    transform: "translate(-24.111 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34825",
    "data-name": "Path 34825",
    d: "M66.056,5.289H61.727a1.074,1.074,0,0,1-1.115-1.025V.286a.312.312,0,0,1,.622,0V4.264a.475.475,0,0,0,.493.453h4.329a.287.287,0,1,1,0,.572Z",
    transform: "translate(-45.143)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65837",
    "data-name": "Group 65837",
    transform: "translate(1.967 7.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34826",
    "data-name": "Path 34826",
    d: "M18.887,28.967H17.522a.3.3,0,0,1-.311-.286V26.6a.3.3,0,0,1,.311-.286h1.365a.927.927,0,0,1,.963.885v.881A.927.927,0,0,1,18.887,28.967Zm-1.053-.572h1.053a.328.328,0,0,0,.34-.313V27.2a.328.328,0,0,0-.34-.313H17.833Z",
    transform: "translate(-17.211 -26.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34827",
    "data-name": "Path 34827",
    d: "M17.522,35.583a.3.3,0,0,1-.311-.286V33.874a.312.312,0,0,1,.622,0V35.3A.3.3,0,0,1,17.522,35.583Z",
    transform: "translate(-17.211 -31.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34828",
    "data-name": "Path 34828",
    d: "M31.1,30.39h-1.3a.3.3,0,0,1-.311-.286V26.6a.3.3,0,0,1,.311-.286h1.3a.992.992,0,0,1,1.03.946v2.182A.992.992,0,0,1,31.1,30.39Zm-.987-.572H31.1a.392.392,0,0,0,.408-.375V27.262a.393.393,0,0,0-.408-.375h-.987Z",
    transform: "translate(-25.673 -26.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34829",
    "data-name": "Path 34829",
    d: "M42.314,30.39A.3.3,0,0,1,42,30.1V26.6a.312.312,0,0,1,.622,0v3.5A.3.3,0,0,1,42.314,30.39Z",
    transform: "translate(-34.29 -26.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34830",
    "data-name": "Path 34830",
    d: "M44.33,26.888H42.314a.287.287,0,1,1,0-.572H44.33a.287.287,0,1,1,0,.572Z",
    transform: "translate(-34.29 -26.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34831",
    "data-name": "Path 34831",
    d: "M43.635,33.014H42.314a.287.287,0,1,1,0-.572h1.321a.287.287,0,1,1,0,.572Z",
    transform: "translate(-34.29 -30.691)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34832",
    "data-name": "Path 34832",
    d: "M24.078,28.149H11.838a.9.9,0,0,1-.949-.851V21.933a.9.9,0,0,1,.949-.851H24.078a.9.9,0,0,1,.949.851V27.3A.905.905,0,0,1,24.078,28.149Zm-12.24-6.495a.306.306,0,0,0-.326.279V27.3a.306.306,0,0,0,.326.279H24.078A.306.306,0,0,0,24.4,27.3V21.933a.306.306,0,0,0-.327-.279H11.838Z",
    transform: "translate(-10.889 -15.055)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34833",
    "data-name": "Path 34833",
    d: "M38.443,66.3a.868.868,0,0,1-.588-.223L34.282,62.8a.529.529,0,0,1-.133-.614.614.614,0,0,1,.566-.348h1.1V57.488a.693.693,0,0,1,.713-.669h3.82a.693.693,0,0,1,.713.669v4.348h1.1a.614.614,0,0,1,.566.347.529.529,0,0,1-.133.614L39.03,66.081A.868.868,0,0,1,38.443,66.3Zm-3.727-3.9,3.58,3.269a.222.222,0,0,0,.3,0l3.557-3.269H40.755a.3.3,0,0,1-.311-.286V57.488a.094.094,0,0,0-.091-.1h-3.82a.1.1,0,0,0-.091.1v4.634a.3.3,0,0,1-.311.286Zm7.455,0h0Z",
    transform: "translate(-26.88 -40.575)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34834",
    "data-name": "Path 34834",
    d: "M22.158,54.992H18.19A1.149,1.149,0,0,1,17,53.9V44.087a.312.312,0,0,1,.622,0V53.9a.55.55,0,0,0,.571.525h3.968a.287.287,0,1,1,0,.572Z",
    transform: "translate(-15.097 -31.279)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34835",
    "data-name": "Path 34835",
    d: "M35.128,23.713H31.063a.287.287,0,1,1,0-.572h4.066a.55.55,0,0,0,.571-.525V5.338a.5.5,0,0,0-.167-.371L30.916.725a.594.594,0,0,0-.4-.154H18.19a.55.55,0,0,0-.571.525V6.313a.312.312,0,0,1-.622,0V1.1A1.149,1.149,0,0,1,18.19,0H30.512a1.243,1.243,0,0,1,.844.321l4.616,4.242a1.046,1.046,0,0,1,.35.775V22.616A1.149,1.149,0,0,1,35.128,23.713Z",
    transform: "translate(-15.097)",
    stroke: "#000",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicePdf);
export default __webpack_public_path__ + "static/media/invoicePdf.958d116aff2d070343d01442ce44822d.svg";
export { ForwardRef as ReactComponent };